/**
 * Collapse a query string to one string per key, keeping the first value.
 *
 * Landing CTAs put the canonical attribution code first (`source=LilyLime`) and
 * Poppy's Webflow script appends the visitor's original query string after it
 * (`source=LilyLim`). `Object.fromEntries(URLSearchParams)` and
 * `URLSearchParams.set` inside `forEach` keep the last value, so the CRM stored
 * the old code. Set each key only when it is not already an own property.
 */
export const searchParamsToFirstValueObject = (searchParams: URLSearchParams): Record<string, string> => {
  const obj: Record<string, string> = {}
  searchParams.forEach((value, key) => {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) {
      obj[key] = value
    }
  })
  return obj
}
